import React from "react";

import { useNavigateToLink } from "../../../components/react/link";
import { NOTIFICATIONS_PATH } from "../../Routes";
import { BreadcrumbLayout } from "../BreadcrumbLayout";

export const NotificationsAddBreadcrumb: React.FC = () => {
	const link = useNavigateToLink(NOTIFICATIONS_PATH, {
		params: { id: "new" },
		search: ["timeRange", "timestamp", "detachedFilters"],
	});

	return <BreadcrumbLayout label="Add new notification" to={link} />;
};
